import React from 'react';
import { ShareToolFilter } from '@/views/SavedQueries/types';
import { FilterItem } from './subcomponents/FilterItem';

const FILTER_ITEMS: ShareToolFilter[] = [
  'SLACK',
  'EMAIL',
  'GOOGLE',
  'S3_BUCKETS',
  'ZAPIER',
];

export type ShareToolFiltersProps = {
  onApplyFilter: F<ShareToolFilter, void>;
  appliedFilter: Maybe<ShareToolFilter>;
  getSavedQueriesCount: F<ShareToolFilter, number>;
};

export const ShareToolFilters: React.FC<ShareToolFiltersProps> = ({
  onApplyFilter,
  appliedFilter,
  getSavedQueriesCount,
}) => (
  <>
    {FILTER_ITEMS.map((type) => (
      <FilterItem
        key={type}
        type={type}
        onApplyFilter={() => onApplyFilter(type)}
        active={type === appliedFilter}
        count={getSavedQueriesCount(type)}
      />
    ))}
  </>
);
